
import { Injectable, EventEmitter } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpParams, HttpHeaders, HttpRequest } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class OrgService {
  public orgApiUrl = environment.apibaseUrl + '/organization';
  orgListLoad = false;
  orgImageURL = '';

  constructor(private http: HttpClient) {
  }

  getOrganizationList() {
    return this.http.get(this.orgApiUrl + '/organizationlist');
  }

  getOrganizationDetails(orgId) {
    return this.http.get(this.orgApiUrl + '/organizationdetails/?organizationId=' + orgId);
  }

  saveOrganization(orgName: string, orgId, logoImage: any, appointmentTypesList: number[],
    themeId, organizationTypeId, waitingRoomlevelId,
    isClientAppointmentBook, isEnableClientMap, appLogoheight, appLogowidth,
    loginLogoHeight, loginLogoWidth, isEnableSponsor,
    sponsorLogoList, removedSponsorIdList, isEnableDonation, paymentUrl,
     isAllowMultipleClinician, isAllowMultipleLocation, numberOfSocialWorkers) {
    const details = new FormData();
    details.append('ClinicalOrgId', orgId);
    details.append('ClinicalOrgName', orgName);
    details.append('LogoImage', logoImage);
    details.append('ThemeId', themeId);
    details.append('OrganizationTypeId', organizationTypeId);
    details.append('WaitingRoomlevelId', waitingRoomlevelId);
    details.append('IsClientAppointmentBook', isClientAppointmentBook);
    details.append('IsEnableClientMap', isEnableClientMap);
    details.append('AppLogoHeight', appLogoheight);
    details.append('AppLogoWidth', appLogowidth);
    details.append('LoginLogoHeight', loginLogoHeight);
    details.append('LoginLogoWidth', loginLogoWidth);
    details.append('IsEnableSponsor', isEnableSponsor);
    details.append('IsAllowMultipleClinician', isAllowMultipleClinician);
    details.append('IsAllowMultipleLocation', isAllowMultipleLocation);
    details.append('NumberOfSocialWorkers', numberOfSocialWorkers);

    appointmentTypesList.forEach(element => {
      details.append('AppointmentTypes', JSON.stringify(element));
    });

    if (sponsorLogoList.length > 0) {
      sponsorLogoList.forEach(element => {
        if (element.sponsorLogoImage != null) {
          details.append('SponsorLogo', element.sponsorLogoImage as any);
          details.append('WebsiteUrl', element.websiteUrl as any);
        }
      });
    }
    details.append('IsEnableDonation', isEnableDonation);
    details.append('PaymentUrl', paymentUrl);

    if (removedSponsorIdList.length > 0) {
      removedSponsorIdList.forEach(element => {
        details.append('RemovedSponsorIdList', JSON.stringify(element));
      });
    }

    return this.http.post(this.orgApiUrl + '/SaveClinicalOrganisation', details);
  }

  // Get organization based on the user org id
  getCurrentOrganizationDetails() {
    return this.http.get(this.orgApiUrl + '/organizationdetails');
  }

  getThemes() {
    return this.http.get(this.orgApiUrl + '/theme');
  }

  getOrgThemes(OrgId) {
    return this.http.get(this.orgApiUrl + '/orgThemeList?ClinicaOrgId=' + OrgId);
  }

  getOrganizationTheme() {
    return this.http.get(this.orgApiUrl + '/orgtheme');
  }

  getOrganizationType() {
    return this.http.get(this.orgApiUrl + '/organizationType');
  }

  getWaitingRoomLevelType() {
    return this.http.get(this.orgApiUrl + '/waitingRoomLeveltype');
  }

  public checkorgansiationtype(cname) {
    return this.http.post(this.orgApiUrl + '/checkorgansiationtype', cname);
  }

  getMappingClinicianList(clinicIds) {
    return this.http.post(this.orgApiUrl + '/mappingClinicianList', clinicIds);
  }
GetAllClinicianListByOrgid() {
    return this.http.get(this.orgApiUrl + '/counselor/SocialWorker/ByOrgId');
  }
  getSponsorLogoList() {
    return this.http.get(this.orgApiUrl + '/sponsorLogoList');
  }

  markOrgActiveOrInactive(OrgId, isActiveInactive) {
    return this.http.get(this.orgApiUrl + '/markOrgActiveInactive?orgId=' + OrgId + '&isActiveInactive=' + isActiveInactive);
  }

}
